document.addEventListener("fg-gifts:show-slider", function () {
  const freegiftsContainer = document.getElementById(
    "freegifts-main-popup-container"
  );
  if (!freegiftsContainer) return;

  const slideContainer = freegiftsContainer.querySelector(".slide-container");
  const gliderTrack = freegiftsContainer.querySelector(".glider-track");
  const productItems = freegiftsContainer.querySelectorAll(".product-item");

  if (slideContainer) {
    freegiftsContainer.style.setProperty(
      "--slide-container-width",
      `${slideContainer.offsetWidth}px`
    );
    slideContainer.style.maxWidth = "unset";
  }

  if (gliderTrack) {
    freegiftsContainer.style.setProperty(
      "--glider-track-width",
      `${gliderTrack.offsetWidth}px`
    );
  }

  const productItemAmount = Math.max(productItems.length, 1);
  freegiftsContainer.style.setProperty(
    "--product-item-amount",
    productItemAmount.toString()
  );
});

window.addEventListener("resize", function () {
  const freegiftsContainer = document.getElementById(
    "freegifts-main-popup-container"
  );
  if (!freegiftsContainer) return;

  const fgSectionTitle = freegiftsContainer.querySelector(".fg-section-title");
  const gliderTrack = freegiftsContainer.querySelector(".glider-track");
  if (fgSectionTitle && gliderTrack) fgSectionTitle.style.maxWidth = gliderTrack.offsetWidth + "px";
});
